import Map from "./components/Map";
import Home from "./pages/Home";


function App() {
  return (
    <>
      <Home />
      {/* <Map/> */}
    </>
  );
}

export default App;
